import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { skip, Subject, Subscription, takeUntil } from 'rxjs';
import { FiltroBuscaSalvaIndustrialComponent } from 'src/app/shared/components/filtros-busca/filtro-busca-salva-industrial/filtro-busca-salva-industrial.component';
import { FiltroBuscaSomenteComponent } from 'src/app/shared/components/filtros-busca/filtro-busca-somente/filtro-busca-somente.component';
import { FiltroCadastradaEmComponent } from 'src/app/shared/components/filtros-busca/filtro-cadastrada-em/filtro-cadastrada-em.component';
import { FiltroCronogramaComponent } from 'src/app/shared/components/filtros-busca/filtro-cronograma/filtro-cronograma.component';
import { FiltroDetalhesObraComponent } from 'src/app/shared/components/filtros-busca/filtro-detalhes-obra/filtro-detalhes-obra.component';
import { FiltroRegiaoIndustrialComponent } from 'src/app/shared/components/filtros-busca/filtro-regiao-industrial/filtro-regiao-industrial.component';
import { FiltroSetorObraComponent } from 'src/app/shared/components/filtros-busca/filtro-setor-obra/filtro-setor-obra.component';
import { FiltroTerminoObraComponent } from 'src/app/shared/components/filtros-busca/filtro-termino-obra/filtro-termino-obra.component';
import { FiltroTipoObraIndustrialComponent } from 'src/app/shared/components/filtros-busca/filtro-tipo-obra-industrial/filtro-tipo-obra-industrial.component';
import { FiltroValorObraComponent } from 'src/app/shared/components/filtros-busca/filtro-valor-obra/filtro-valor-obra.component';
import { FiltroBuscaService } from 'src/app/shared/components/filtros-busca/service/filtro-busca-service/filtro-busca.service';
import { ResultadoFiltroService } from 'src/app/shared/components/filtros-busca/service/resultado-service/resultado-filtros.service';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { environment } from 'src/environments/environment';
import {
  ModalMensagemComponent,
  TipoModalMensagem,
} from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';
import { PaginacaoFiltrosService } from '../service/paginacao-filtros.service';
import { FiltroBuscaEstadoService } from '../service/filtro-busca-estado.service';

const STORAGE_KEY = 'filtros_busca_outros_modulos';

export function getFiltrosSafe(): any[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    let parsed: any = raw;
    let attempts = 0;
    while ((typeof parsed === 'string' || parsed === null) && attempts < 5) {
      const trimmed = String(parsed).trim();
      if (trimmed === '' || trimmed === 'null') return [];
      if (/^["\[{]/.test(trimmed)) {
        try {
          parsed = JSON.parse(trimmed);
        } catch (err) {
          return [];
        }
      } else {
        break;
      }
      attempts++;
    }
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
}

export function setFiltrosSafe(filtros: any[]): void {
  try {
    let toSave = filtros;
    if (typeof filtros === 'string') {
      try {
        toSave = JSON.parse(filtros);
      } catch {
        return;
      }
    }

    if (!Array.isArray(toSave)) {
      return;
    }

    const unique = Array.from(
      new Set(toSave.map((f: any) => JSON.stringify(f))),
    ).map((s) => JSON.parse(s));

    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
  } catch (err) {
    console.warn('[FiltroImobiliario] Erro ao salvar localStorage:', err);
  }
}

@Component({
  selector: 'app-filtro-busca-infra-edificacoes-industrial',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DropdownToggleDirective,
    FiltroBuscaSalvaIndustrialComponent,
    FiltroSetorObraComponent,
    FiltroDetalhesObraComponent,
    FiltroRegiaoIndustrialComponent,
    FiltroCronogramaComponent,
    FiltroValorObraComponent,
    FiltroTerminoObraComponent,
    FiltroTipoObraIndustrialComponent,
    FiltroCadastradaEmComponent,
    FiltroBuscaSomenteComponent,
    ModalMensagemComponent,
  ],
  templateUrl: './filtro-busca-infra-edificacoes-industrial.component.html',
  styleUrls: ['./filtro-busca-infra-edificacoes-industrial.component.scss'],
})
export class FiltroBuscaInfraEdificacoesIndustrialComponent
  implements OnInit, OnDestroy, OnChanges
{
  modoEdicao: boolean = false;
  buscaSalvaId: number | null = null;
  savedSearchName: string = '';

  modalMensagem: {
    tipo: TipoModalMensagem;
    titulo: string;
    mensagem: string;
  } | null = null;
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  idEditandoBusca: number | null = null;

  setoresSelecionados: any[] = [];
  tiposObraSelecionados: any[] = [];
  detalhesSelecionados: any[] = [];
  cronogramaSelecionados: any[] = [];
  filtrosSelecionados: any = { noResponsible: 1, noDiscardedWork: 1 };
  filtrosBuscaSalvaAtivos: any = null;

  inputNomeBusca: boolean = false;

  public bloqueandoAtualizacao: boolean = false;
  private chamadaInicialFeita = false;
  private restaurandoEstado = false;
  private estadoRestauracaoPendente: any = null;

  terminoObraSelecionado: {
    dataInicio: string | null;
    dataFim: string | null;
  } = { dataInicio: null, dataFim: null };

  buscarSomenteSelecionados: any[] = [
    {
      id: 1,
      description: 'Buscar somente obras sem responsáveis',
      checked: true,
    },
    {
      id: 2,
      description: 'Não incluir obras descartadas',
      checked: true,
    },
  ];

  cadastradaEmSelecionado: any = {
    value: 0,
    description: 'Indiferente',
    checked: true,
  };

  valorObraSelecionado: { de: number | null; ate: number | null } = {
    de: null,
    ate: null,
  };

  regiaoFiltro: {
    regiao?: number;
    addressStateID?: string;
    addressCityID?: string;
  } = {};

  @Output() resultadoChange = new EventEmitter<any>();
  @Output() loadingChange = new EventEmitter<boolean>();

  @Input() idModuloSelecionado: number;
  @Input() temAcessoModulo: boolean = false;

  @ViewChild('nomeBuscaInput') nomeBuscaInput!: ElementRef<HTMLInputElement>;
  @ViewChild('nomeBuscaEditadaInput')
  nomeBuscaEditadaInput?: ElementRef<HTMLInputElement>;
  @ViewChild(FiltroBuscaSalvaIndustrialComponent)
  filtroBuscaSalvaComp?: FiltroBuscaSalvaIndustrialComponent;
  @ViewChild(FiltroRegiaoIndustrialComponent)
  filtroRegiaoComp?: FiltroRegiaoIndustrialComponent;

  private paginacaoSub?: Subscription;
  private jaInicializou = false;
  private jaChamouApiModulo = false;
  private filtroApiTimeout: any = null;
  private ultimoBodyEnviado: string = '';
  private ultimoBuscaSalvaIdCarregado: number | null = null;
  private carregandoBuscaSalva: boolean = false;
  private buscaSalvaAlterada: boolean = false;
  private esperandoComponentesBuscaSalva: {
    detalhes?: boolean;
    tipos?: boolean;
    setores?: boolean;
    cronograma?: boolean;
  } = {};
  private pollTimeoutBuscaSalva: any = null;
  private savedSearchApiDispatched: boolean = false;
  private regiaoInicializada: boolean = false;
  private ordenacaoAtual: string = 'date:desc';

  private destroy$ = new Subject<void>();

  constructor(
    private readonly paginacaoService: PaginacaoFiltrosService,
    private readonly _filtroBuscaService: FiltroBuscaService,
    private readonly resultadoService: ResultadoFiltroService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly filtroBuscaEstado: FiltroBuscaEstadoService,
  ) {}

  private exibirMensagem(
    tipo: TipoModalMensagem,
    titulo: string,
    mensagem: string,
  ): void {
    this.modalMensagem = { tipo, titulo, mensagem };
  }

  onFecharModalMensagem(): void {
    this.modalMensagem = null;
  }

  ngOnInit() {
    const win: any = window as any;
    const buscaSalvaASP =
      win.buscaSalvaIdASP !== undefined
        ? win.buscaSalvaIdASP
        : win.idBuscaASP !== undefined
          ? win.idBuscaASP
          : null;

    let restauradoDaSessao = false;

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const buscaIdQuery = params['buscaSalvaId'];
        const resolvedId = this.resolveBuscaSalvaId(
          buscaIdQuery,
          buscaSalvaASP,
        );

        if (resolvedId) {
          if (resolvedId === this.buscaSalvaId) {
            return;
          }

          this.modoEdicao = true;
          this.buscaSalvaId = resolvedId;
          this.popularBuscaSalvaPorId(resolvedId);
        } else {
          this.modoEdicao = false;
          this.buscaSalvaId = null;

          const estadoSalvo = this.filtroBuscaEstado.recuperar(
            this.idModuloSelecionado || 5,
          );
          const idRestaurado = this.extrairBuscaSalvaIdValido(
            estadoSalvo?.buscaSalvaId,
          );
          if (idRestaurado) {
            this.buscaSalvaId = idRestaurado;
            this.savedSearchName =
              estadoSalvo.savedSearchName ?? this.savedSearchName;
            restauradoDaSessao = true;
          }
        }
      });

    setTimeout(() => {
      if (!restauradoDaSessao && (this.buscaSalvaId || this.filtrosBuscaSalvaAtivos)) {
        return;
      }
      const estado = this.filtroBuscaEstado.recuperar(
        this.idModuloSelecionado || 5,
      );
      if (estado?.filtros?.length) {
        this.restaurandoEstado = true;
        this.estadoRestauracaoPendente = estado;
      }
    });

    this.paginacaoSub = this.paginacaoService.paginacao$
      .pipe(skip(1), takeUntil(this.destroy$))
      .subscribe((pag) => {
        this.salvarFiltrosNoLocalStorage(pag);
      });
  }

  ngOnDestroy() {
    this.paginacaoSub?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['idModuloSelecionado'] &&
      !changes['idModuloSelecionado'].firstChange &&
      this.jaInicializou
    ) {
      this.setoresSelecionados = [];
      this.tiposObraSelecionados = [];
      this.detalhesSelecionados = [];
      if (!this.jaChamouApiModulo) {
        this.jaChamouApiModulo = true;
        setTimeout(() => {
          this.salvarFiltrosNoLocalStorage();
        }, 0);
      }
    }
  }

  private resolveBuscaSalvaId(queryId: any, aspId: any): number | null {
    const raw = queryId ?? aspId;
    if (raw === null || raw === undefined) return null;
    if (isNaN(Number(raw))) return null;
    return Number(raw) > 0 ? Number(raw) : null;
  }

  public popularBuscaSalvaPorId(searchID: number): void {
    if (!searchID) {
      return;
    }

    if (this.carregandoBuscaSalva && this.buscaSalvaId === searchID) {
      return;
    }

    this.bloqueandoAtualizacao = true;
    this.buscaSalvaId = searchID;
    this.carregandoBuscaSalva = true;

    this.resultadoService
      .resultadoBuscaSalvaIndustrial(searchID, this.idModuloSelecionado)
      .subscribe({
        next: (response) => {
          if (response.success && response.data) {
            this.aplicarFiltrosSalvos(response.data);
            this.idEditandoBusca = searchID;

            setTimeout(() => {
              this.filtroBuscaSalvaComp?.setSelectedBusca(searchID, true);
            }, 0);
          }
          this.bloqueandoAtualizacao = false;
          this.carregandoBuscaSalva = false;
          this.ultimoBuscaSalvaIdCarregado = searchID;
        },
        error: (error) => {
          this.bloqueandoAtualizacao = false;
          this.carregandoBuscaSalva = false;
        },
      });
  }

  private aplicarFiltrosSalvos(filtrosData: any): void {
    const norm = this.normalizeFiltroData(filtrosData);

    this.setoresSelecionados = norm.SectorID
      ? String(norm.SectorID)
          .split(',')
          .map((id) => ({
            id: Number(id),
            checked: true,
            description: 'Setor ' + id,
          }))
      : [];

    this.detalhesSelecionados = norm.InfoID
      ? String(norm.InfoID)
          .split(',')
          .map((id) => ({
            id: Number(id),
            checked: true,
            description: 'Detalhe ' + id,
          }))
      : [];

    this.tiposObraSelecionados = norm.WorkTypeID
      ? String(norm.WorkTypeID)
          .split(',')
          .map((id) => ({
            id: Number(id),
            checked: true,
            description: 'Tipo de Obra ' + id,
          }))
      : [];

    this.cronogramaSelecionados = norm.ScheduleID
      ? String(norm.ScheduleID)
          .split(',')
          .map((id) => ({
            id: Number(id),
            checked: true,
            description: 'Cronograma ' + id,
          }))
      : [];

    this.valorObraSelecionado = {
      de: norm.ValueBegin ? Number(norm.ValueBegin) : null,
      ate: norm.ValueEnd ? Number(norm.ValueEnd) : null,
    };

    this.buscarSomenteSelecionados = [
      {
        id: 1,
        description: 'Buscar somente obras sem responsáveis',
        checked: norm.noResponsible === 1,
      },
      {
        id: 2,
        description: 'Não incluir obras descartadas',
        checked: norm.noDiscardedWork === 1,
      },
    ];

    this.regiaoFiltro = {
      regiao: norm.AddressRegionID ? Number(norm.AddressRegionID) : undefined,
      addressStateID: norm.AddressStateID
        ? String(norm.AddressStateID)
        : undefined,
      addressCityID: norm.AddressCityID
        ? String(norm.AddressCityID)
        : undefined,
    };

    this.cadastradaEmSelecionado = {
      value: norm.DateRegisteredUpdated
        ? Number(norm.DateRegisteredUpdated)
        : 0,
      description: '',
      checked: true,
    };

    this.terminoObraSelecionado = {
      dataInicio: norm.WorkEndDateBegin ?? null,
      dataFim: norm.WorkEndDateEnd ?? null,
    };

    this.filtrosBuscaSalvaAtivos = norm;
    this.savedSearchName = norm.savedSearchName || this.savedSearchName;

    this.filtrosSelecionados = {
      noResponsible: this.buscarSomenteSelecionados.find((b) => b.id === 1)
        ?.checked
        ? 1
        : 0,
      noDiscardedWork: this.buscarSomenteSelecionados.find((b) => b.id === 2)
        ?.checked
        ? 1
        : 0,
      sectorID: norm.SectorID || '0',
      infoID: norm.InfoID || '0',
      workTypeID: norm.WorkTypeID || '0',
      scheduleID: norm.ScheduleID || '0',
      dateRegisteredUpdated: this.cadastradaEmSelecionado.value,
      workEndDateBegin: this.terminoObraSelecionado.dataInicio,
      workEndDateEnd: this.terminoObraSelecionado.dataFim,
    };

    this.buscaSalvaAlterada = false;
    this.esperandoComponentesBuscaSalva = {};
    if (norm.InfoID) this.esperandoComponentesBuscaSalva.detalhes = false;
    if (norm.WorkTypeID) this.esperandoComponentesBuscaSalva.tipos = false;
    if (norm.SectorID) this.esperandoComponentesBuscaSalva.setores = false;
    if (norm.ScheduleID) this.esperandoComponentesBuscaSalva.cronograma = false;

    this.bloqueandoAtualizacao = false;
    this.savedSearchApiDispatched = false;
    this.dispatchSavedSearchApi();
    this.iniciarPollBuscaSalva();
  }

  onBuscaSalvaChange(buscaId: number) {
    this.buscaSalvaId = buscaId || null;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { buscaSalvaId: buscaId || null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });

    if (buscaId > 0) {
      if (buscaId !== this.ultimoBuscaSalvaIdCarregado) {
        this.popularBuscaSalvaPorId(buscaId);
      } else {
        console.debug('Busca já carregada, não recarregando:', buscaId);
      }
    }
  }

  atualizarPaginacao(page: number, pageSize: number, ordenation?: string) {
    this.salvarFiltrosNoLocalStorage({ page, pageSize, ordenation });
  }

  private extrairBuscaSalvaIdValido(valor: unknown): number | null {
    return typeof valor === 'number' && valor > 0 ? valor : null;
  }

  get checkedBuscarSomenteIds(): number[] {
    const arr: number[] = [];
    if (
      this.filtrosSelecionados &&
      this.filtrosSelecionados.noResponsible === 1
    )
      arr.push(1);
    if (
      this.filtrosSelecionados &&
      this.filtrosSelecionados.noDiscardedWork === 1
    )
      arr.push(2);
    return arr;
  }

  onTerminoObraSelecionado(termino: {
    dataInicio: string | null;
    dataFim: string | null;
  }) {
    if (this.bloqueandoAtualizacao) return;

    this.terminoObraSelecionado = termino;
    this.salvarFiltrosNoLocalStorage();
  }

  onSetorSelecionado(selecionados: any[]) {
    if (this.bloqueandoAtualizacao) return;

    this.marcarComponentePronto('setores', selecionados);
    this.marcarAlteracaoBuscaSalva();
    this.setoresSelecionados = selecionados;
    this.salvarFiltrosNoLocalStorage();
  }

  onDetalheSelecionado(selecionados: any[]) {
    if (this.bloqueandoAtualizacao) return;

    this.marcarComponentePronto('detalhes', selecionados);
    this.marcarAlteracaoBuscaSalva();
    this.detalhesSelecionados = selecionados;
    this.salvarFiltrosNoLocalStorage();
  }

  onCadastradaEmSelecionado(valor: any) {
    if (this.bloqueandoAtualizacao) return;
    this.marcarAlteracaoBuscaSalva();
    this.cadastradaEmSelecionado = valor;
    this.salvarFiltrosNoLocalStorage();
  }

  onTipoObraSelecionado(selecionados: any[]) {
    if (this.bloqueandoAtualizacao) return;
    this.marcarComponentePronto('tipos', selecionados);
    this.marcarAlteracaoBuscaSalva();
    this.tiposObraSelecionados = selecionados;
    this.salvarFiltrosNoLocalStorage();
  }

  onValorObraSelecionado(valores: { de: number | null; ate: number | null }) {
    if (this.bloqueandoAtualizacao) return;

    this.marcarAlteracaoBuscaSalva();
    this.valorObraSelecionado = valores;
    this.salvarFiltrosNoLocalStorage();
  }

  onCronogramaSelecionado(selecionados: any[]) {
    if (this.bloqueandoAtualizacao) return;

    this.marcarComponentePronto('cronograma', selecionados);
    this.marcarAlteracaoBuscaSalva();
    this.cronogramaSelecionados = selecionados;
    this.salvarFiltrosNoLocalStorage();
  }

  onBuscarSomenteSelecionado(selecionados: any[]) {
    if (this.bloqueandoAtualizacao) return;
    this.marcarAlteracaoBuscaSalva();
    this.buscarSomenteSelecionados = selecionados;

    this.filtrosSelecionados.noResponsible = selecionados.some(
      (o) => o.id === 1 && o.checked,
    )
      ? 1
      : 0;
    this.filtrosSelecionados.noDiscardedWork = selecionados.some(
      (o) => o.id === 2 && o.checked,
    )
      ? 1
      : 0;
    this.salvarFiltrosNoLocalStorage();
  }

  onRegiaoFiltrosChange(filtros: any) {
    if (this.bloqueandoAtualizacao) return;

    if (this.restaurandoEstado && this.estadoRestauracaoPendente) {
      const estado = this.estadoRestauracaoPendente;
      this.regiaoFiltro = estado.regiao ?? filtros;
      this.regiaoInicializada = true;
      this.restaurarEstadoSessao(estado);
      this.restaurandoEstado = false;
      this.estadoRestauracaoPendente = null;
      return;
    }

    this.marcarAlteracaoBuscaSalva();
    this.regiaoFiltro = filtros;
    this.regiaoInicializada = true;

    setTimeout(() => {
      this.salvarFiltrosNoLocalStorage();
    }, 0);
  }

  get buscaSalvaRegiao(): any {
    const raw = this.filtrosBuscaSalvaAtivos;
    if (!raw) return null;

    const addressRegionID =
      raw.AddressRegionID ?? raw.addressRegionID ?? raw.addressRegionId ?? null;
    const addressStateID =
      raw.AddressStateID ?? raw.addressStateID ?? raw.addressStateId ?? null;
    const addressCityID =
      raw.AddressCityID ?? raw.addressCityID ?? raw.addressCityId ?? null;

    return {
      addressRegionID:
        addressRegionID !== null && addressRegionID !== undefined
          ? Number(addressRegionID)
          : null,
      addressStateID:
        addressStateID !== null && addressStateID !== undefined
          ? String(addressStateID)
          : null,

      addressCityID:
        addressCityID !== null && addressCityID !== undefined
          ? String(addressCityID)
          : null,
    };
  }

  salvarFiltrosNoLocalStorage(
    paginacao?: { page: number; pageSize: number; ordenation?: string },
    limparBuscaSalva?: boolean,
    fromBuscaSalvaAplicada?: boolean,
  ) {
    this.ordenacaoAtual = paginacao?.ordenation ?? this.ordenacaoAtual;

    const deveConsumirBloqueio =
      this.bloqueandoAtualizacao &&
      !this.buscaSalvaAlterada &&
      !fromBuscaSalvaAplicada;

    if (deveConsumirBloqueio) {
      this.bloqueandoAtualizacao = false;
    }

    if (
      limparBuscaSalva ||
      (!fromBuscaSalvaAplicada && this.filtrosBuscaSalvaAtivos)
    ) {
      this.filtrosBuscaSalvaAtivos = null;
      this.buscaSalvaId = null;
      this.buscaSalvaAlterada = true;
    }

    clearTimeout(this.filtroApiTimeout);
    this.filtroApiTimeout = setTimeout(() => {
      if (!this.regiaoInicializada && !fromBuscaSalvaAplicada) {
        return;
      }
      if (this.shouldUseSavedSearch(fromBuscaSalvaAplicada)) {
        const body = this.buildBodyFromSavedSearch(
          paginacao,
          fromBuscaSalvaAplicada,
        );
        this.filtroBuscaEstado.salvar(this.idModuloSelecionado || 5, {
          filtros: this.buildFiltrosArray(),
          paginacao: paginacao ?? this.paginacaoService.getPaginacao(),
          regiao: this.regiaoFiltro,
          buscaSalvaId: this.buscaSalvaId,
          savedSearchName: this.savedSearchName,
        });
        this.dispatchBody(body, 'busca-salva');
        return;
      }
      const filtros = this.buildFiltrosArray();
      this.saveFiltrosLocalStorage(filtros);
      this.filtroBuscaEstado.salvar(this.idModuloSelecionado || 5, {
        filtros,
        paginacao: paginacao ?? this.paginacaoService.getPaginacao(),
        regiao: this.regiaoFiltro,
        buscaSalvaId: this.buscaSalvaId,
        savedSearchName: this.savedSearchName,
      });
      const body = this.buildBodyFromFiltros(filtros, paginacao);
      this.dispatchBody(body, 'manual');
    }, 150);
  }

  private shouldUseSavedSearch(fromBuscaSalvaAplicada?: boolean): boolean {
    return !!(
      this.filtrosBuscaSalvaAtivos &&
      !this.buscaSalvaAlterada &&
      fromBuscaSalvaAplicada
    );
  }

  private buildBodyFromSavedSearch(
    paginacao?: { page: number; pageSize: number; ordenation?: string },
    fromBuscaSalvaAplicada?: boolean,
  ): any {
    const filtrosSalvos = this.filtrosBuscaSalvaAtivos || {};
    const regiao = this.buscaSalvaRegiao || {};
    const get = (...cands: string[]) => {
      for (const c of cands) {
        if (
          filtrosSalvos[c] !== undefined &&
          filtrosSalvos[c] !== null &&
          filtrosSalvos[c] !== ''
        ) {
          return filtrosSalvos[c];
        }
      }
      return undefined;
    };
    const body: any = {
      workModulesID: this.idModuloSelecionado || 5,
      addressRegionID: Number(
        get('AddressRegionID', 'addressRegionID', 'addressRegionId') ??
          regiao.addressRegionID ??
          0,
      ),
      addressStateID: String(
        regiao.addressStateID ??
          get('AddressStateID', 'addressStateID', 'addressStateId') ??
          '0',
      ),
      addressCityID: String(
        regiao.addressCityID ??
          get('AddressCityID', 'addressCityID', 'addressCityId') ??
          '0',
      ),
      infoID: get('InfoID', 'infoID', 'infoId') ?? '0',
      sectorID: get('SectorID', 'sectorID', 'sectorId') ?? '0',
      workTypeID: get('WorkTypeID', 'workTypeID', 'workTypeId') ?? '0',
      scheduleID: get('ScheduleID', 'scheduleID', 'scheduleId') ?? '0',
      valueBegin: Number(get('ValueBegin', 'valueBegin', 'valuebegin') ?? 0),
      valueEnd: Number(get('ValueEnd', 'valueEnd', 'valueend') ?? 999999999),
      dateRegisteredUpdated: Number(
        get('DateRegisteredUpdated', 'dateRegisteredUpdated') ?? 0,
      ),
      workEndDateBegin: get('WorkEndDateBegin', 'workEndDateBegin') ?? null,
      workEndDateEnd: get('WorkEndDateEnd', 'workEndDateEnd') ?? null,
      noResponsible: Number(get('noResponsible', 'NoResponsible') ?? 1),
      noDiscardedWork: Number(get('noDiscardedWork', 'NoDiscardedWork') ?? 1),
      pagination: {
        page: paginacao?.page ?? 1,
        pageSize: paginacao?.pageSize ?? 50,
        shortcuts: 10,
        ordenation: this.ordenacaoAtual,
      },
    };

    if (fromBuscaSalvaAplicada) {
      if (body.infoID === '0' && this.filtrosSelecionados?.infoID)
        body.infoID = String(this.filtrosSelecionados.infoID);
      if (body.workTypeID === '0' && this.filtrosSelecionados?.workTypeID)
        body.workTypeID = String(this.filtrosSelecionados.workTypeID);
      if (body.sectorID === '0' && this.filtrosSelecionados?.sectorID)
        body.sectorID = String(this.filtrosSelecionados.sectorID);
      if (body.scheduleID === '0' && this.filtrosSelecionados?.scheduleID)
        body.scheduleID = String(this.filtrosSelecionados.scheduleID);
    }
    return body;
  }

  private buildFiltrosArray(): any[] {
    const filtros: any[] = [];
    const pushArr = (arr: any[], grupo: string) => {
      if (!Array.isArray(arr)) return;
      arr.forEach((item) => {
        filtros.push({
          filtroGrupo: grupo,
          filtroID: item.id,
          checked: item.checked,
          description: item.description,
        });
      });
    };
    pushArr(this.setoresSelecionados, 'Setor');
    pushArr(this.detalhesSelecionados, 'Detalhes da Obra');
    pushArr(this.tiposObraSelecionados, 'Tipo de Obra');
    pushArr(this.cronogramaSelecionados, 'Cronograma');

    if (this.valorObraSelecionado?.de != null)
      filtros.push({
        filtroGrupo: 'Valor da Obra De',
        filtroID: this.valorObraSelecionado.de,
      });
    if (this.valorObraSelecionado?.ate != null)
      filtros.push({
        filtroGrupo: 'Valor da Obra Ate',
        filtroID: this.valorObraSelecionado.ate,
      });

    pushArr(this.buscarSomenteSelecionados, 'Buscar somente');

    if (this.terminoObraSelecionado?.dataInicio)
      filtros.push({
        filtroGrupo: 'Término da Obra',
        tipo: 'dataInicio',
        valor: this.terminoObraSelecionado.dataInicio,
      });
    if (this.terminoObraSelecionado?.dataFim)
      filtros.push({
        filtroGrupo: 'Término da Obra',
        tipo: 'dataFim',
        valor: this.terminoObraSelecionado.dataFim,
      });

    if (this.cadastradaEmSelecionado?.value != null)
      filtros.push({
        filtroGrupo: 'Cadastrada Em',
        filtroID: this.cadastradaEmSelecionado.value,
      });
    return filtros;
  }

  private restaurarEstadoSessao(estado: any): void {
    const filtros: any[] = Array.isArray(estado?.filtros) ? estado.filtros : [];

    const getArr = (grupo: string) =>
      filtros
        .filter((f) => f.filtroGrupo === grupo)
        .map((f) => ({
          id: Number(f.filtroID),
          checked: !!f.checked,
          description: f.description || `${grupo} ${f.filtroID}`,
        }));

    this.setoresSelecionados = getArr('Setor');
    this.detalhesSelecionados = getArr('Detalhes da Obra');
    this.tiposObraSelecionados = getArr('Tipo de Obra');
    this.cronogramaSelecionados = getArr('Cronograma');

    const valorDe = filtros.find((f) => f.filtroGrupo === 'Valor da Obra De');
    const valorAte = filtros.find((f) => f.filtroGrupo === 'Valor da Obra Ate');
    this.valorObraSelecionado = {
      de: valorDe ? Number(valorDe.filtroID) : null,
      ate: valorAte ? Number(valorAte.filtroID) : null,
    };

    const dataInicio = filtros.find(
      (f) =>
        f.filtroGrupo === 'Término da Obra' && f.tipo === 'dataInicio',
    );
    const dataFim = filtros.find(
      (f) => f.filtroGrupo === 'Término da Obra' && f.tipo === 'dataFim',
    );
    this.terminoObraSelecionado = {
      dataInicio: dataInicio?.valor ?? null,
      dataFim: dataFim?.valor ?? null,
    };

    const cadastrada = filtros.find((f) => f.filtroGrupo === 'Cadastrada Em');
    this.cadastradaEmSelecionado = {
      value: cadastrada ? Number(cadastrada.filtroID) : 0,
      description: cadastrada?.description || 'Indiferente',
      checked: true,
    };

    const buscarSomenteIds = filtros
      .filter(
        (f) =>
          f.filtroGrupo === 'Buscar somente' && f.checked && f.filtroID,
      )
      .map((f) => Number(f.filtroID));
    this.buscarSomenteSelecionados = [
      {
        id: 1,
        description: 'Buscar somente obras sem responsáveis',
        checked: buscarSomenteIds.includes(1),
      },
      {
        id: 2,
        description: 'Não incluir obras descartadas',
        checked: buscarSomenteIds.includes(2),
      },
    ];

    this.filtrosSelecionados = {
      noResponsible: buscarSomenteIds.includes(1) ? 1 : 0,
      noDiscardedWork: buscarSomenteIds.includes(2) ? 1 : 0,
      infoID: this.detalhesSelecionados.map((i) => i.id).join(','),
      sectorID: this.setoresSelecionados.map((i) => i.id).join(','),
      workTypeID: this.tiposObraSelecionados.map((i) => i.id).join(','),
      scheduleID: this.cronogramaSelecionados.map((i) => i.id).join(','),
    };

    this.buscaSalvaId = this.extrairBuscaSalvaIdValido(estado.buscaSalvaId);
    this.savedSearchName = estado.savedSearchName ?? this.savedSearchName;

    const filtrosAtuais = this.buildFiltrosArray();
    this.saveFiltrosLocalStorage(filtrosAtuais);
    this.filtroBuscaEstado.salvar(this.idModuloSelecionado || 5, {
      filtros: filtrosAtuais,
      paginacao: estado.paginacao ?? this.paginacaoService.getPaginacao(),
      regiao: this.regiaoFiltro,
      buscaSalvaId: this.buscaSalvaId,
      savedSearchName: this.savedSearchName,
    });

    const body = this.buildBodyFromFiltros(
      filtrosAtuais,
      estado.paginacao ?? this.paginacaoService.getPaginacao(),
    );
    this.dispatchBody(body, 'manual');
  }

  private saveFiltrosLocalStorage(filtros: any[]): void {
    localStorage.setItem(
      'filtros_busca_outros_modulos',
      JSON.stringify(filtros),
    );
  }

  private buildBodyFromFiltros(
    filtros: any[],
    paginacao?: { page: number; pageSize: number; ordenation?: string },
  ): any {
    let regionIDToSend = this.regiaoFiltro.regiao ?? 0;
    let stateIDToSend = this.regiaoFiltro.addressStateID ?? '0';
    const filtroRegiaoComp = (window as any)
      .filtroRegiaoIndustrialComponentInstance;
    const defaultRegion = filtroRegiaoComp?.defaultRegion;
    const filtroRegiao = filtroRegiaoComp?.filtroRegiao;

    if (
      (!regionIDToSend || Number(regionIDToSend) === 0) &&
      defaultRegion &&
      defaultRegion !== 0
    ) {
      regionIDToSend = defaultRegion;
      if (!stateIDToSend || stateIDToSend === '0') {
        const regiao = filtroRegiao?.find(
          (r: any) => r.regionID === defaultRegion,
        );
        if (regiao?.states?.length)
          stateIDToSend = regiao.states.map((s: any) => s.stateID).join(',');
      }
    }
    const body: any = {
      workModulesID: this.idModuloSelecionado || 5,
      addressRegionID: Number(regionIDToSend),
      addressStateID: stateIDToSend,
      addressCityID: this.regiaoFiltro.addressCityID ?? '0',
      infoID: '',
      sectorID: '',
      workTypeID: '',
      scheduleID: '',
      valueBegin: 0,
      valueEnd: 999999999,
      dateRegisteredUpdated: 0,
      workEndDateBegin: null,
      workEndDateEnd: null,
      noResponsible: 0,
      noDiscardedWork: 0,
      pagination: {
        page: paginacao?.page ?? 1,
        pageSize: paginacao?.pageSize ?? 50,
        shortcuts: 10,
        ordenation: this.ordenacaoAtual,
      },
    };

    filtros.forEach((f) => {
      switch (f.filtroGrupo) {
        case 'Setor':
          body.sectorID += (body.sectorID ? ',' : '') + f.filtroID;
          break;
        case 'Detalhes da Obra':
          body.infoID += (body.infoID ? ',' : '') + f.filtroID;
          break;
        case 'Tipo de Obra':
          body.workTypeID += (body.workTypeID ? ',' : '') + f.filtroID;
          break;
        case 'Cronograma':
          body.scheduleID += (body.scheduleID ? ',' : '') + f.filtroID;
          break;
        case 'Valor da Obra De':
          body.valueBegin = f.filtroID;
          break;
        case 'Valor da Obra Ate':
          body.valueEnd = f.filtroID;
          break;
        case 'Buscar somente':
          if (f.filtroID === 1) body.noResponsible = f.checked ? 1 : 0;
          if (f.filtroID === 2) body.noDiscardedWork = f.checked ? 1 : 0;
          break;
        case 'Término da Obra':
          if (f.tipo === 'dataInicio') body.workEndDateBegin = f.valor;
          if (f.tipo === 'dataFim') body.workEndDateEnd = f.valor;
          break;
        case 'Cadastrada Em':
          body.dateRegisteredUpdated = f.filtroID;
          break;
      }
    });

    if (!body.sectorID) body.sectorID = '0';
    if (!body.infoID) body.infoID = '0';
    if (!body.workTypeID) body.workTypeID = '0';
    if (!body.scheduleID) body.scheduleID = '0';
    return body;
  }

  private dispatchBody(body: any, origin: 'manual' | 'busca-salva'): void {
    const bodyString = JSON.stringify(body);
    if (bodyString === this.ultimoBodyEnviado) return;
    this.ultimoBodyEnviado = bodyString;
    this.loadingChange.emit(true);

    this._filtroBuscaService
      .filterIndustrialBuildingsInfrastructure(body)
      .subscribe({
        next: (res) => {
          this.resultadoChange.emit(res);
          this.loadingChange.emit(false);
        },
        error: (err) => {
          if (origin === 'manual') console.error('Erro na busca:', err);
          this.loadingChange.emit(false);
        },
      });
  }

  public resetUltimoBody(): void {
    this.ultimoBodyEnviado = '';
  }

  private dispatchSavedSearchApi() {
    if (!this.filtrosBuscaSalvaAtivos || this.buscaSalvaAlterada) {
      return;
    }

    if (this.savedSearchApiDispatched) return;
    const filtrosSalvos = this.filtrosBuscaSalvaAtivos;
    const regiao = this.buscaSalvaRegiao || {};
    const get = (...cands: string[]) => {
      for (const c of cands) {
        if (
          filtrosSalvos[c] !== undefined &&
          filtrosSalvos[c] !== null &&
          filtrosSalvos[c] !== ''
        ) {
          return filtrosSalvos[c];
        }
      }
      return undefined;
    };
    const body: any = {
      workModulesID: this.idModuloSelecionado || 5,
      addressRegionID: Number(
        get('AddressRegionID', 'addressRegionID', 'addressRegionId') ??
          regiao.addressRegionID ??
          0,
      ),
      addressStateID: String(
        regiao.addressStateID ??
          get('AddressStateID', 'addressStateID', 'addressStateId') ??
          '0',
      ),
      addressCityID: String(
        regiao.addressCityID ??
          get('AddressCityID', 'addressCityID', 'addressCityId') ??
          '0',
      ),
      infoID: get('InfoID', 'infoID', 'infoId') ?? '0',
      sectorID: get('SectorID', 'sectorID', 'sectorId') ?? '0',
      workTypeID: get('WorkTypeID', 'workTypeID', 'workTypeId') ?? '0',
      scheduleID: get('ScheduleID', 'scheduleID', 'scheduleId') ?? '0',
      valueBegin: Number(get('ValueBegin', 'valueBegin', 'valuebegin') ?? 0),
      valueEnd: Number(get('ValueEnd', 'valueEnd', 'valueend') ?? 999999999),
      dateRegisteredUpdated: Number(
        get('DateRegisteredUpdated', 'dateRegisteredUpdated') ?? 0,
      ),
      workEndDateBegin: get('WorkEndDateBegin', 'workEndDateBegin') ?? null,
      workEndDateEnd: get('WorkEndDateEnd', 'workEndDateEnd') ?? null,
      noResponsible: Number(get('noResponsible', 'NoResponsible') ?? 1),
      noDiscardedWork: Number(get('noDiscardedWork', 'NoDiscardedWork') ?? 1),
      pagination: {
        page: 1,
        pageSize: 50,
        shortcuts: 10,
        ordenation: this.ordenacaoAtual,
      },
    };

    if (body.infoID === '0' && this.filtrosSelecionados?.infoID) {
      body.infoID = String(this.filtrosSelecionados.infoID);
    }
    if (body.workTypeID === '0' && this.filtrosSelecionados?.workTypeID) {
      body.workTypeID = String(this.filtrosSelecionados.workTypeID);
    }
    if (body.sectorID === '0' && this.filtrosSelecionados?.sectorID) {
      body.sectorID = String(this.filtrosSelecionados.sectorID);
    }
    if (body.scheduleID === '0' && this.filtrosSelecionados?.scheduleID) {
      body.scheduleID = String(this.filtrosSelecionados.scheduleID);
    }

    const bodyString = JSON.stringify(body);
    if (bodyString === this.ultimoBodyEnviado) {
      return;
    }
    this.ultimoBodyEnviado = bodyString;
    this.savedSearchApiDispatched = true;
    this.loadingChange.emit(true);

    this._filtroBuscaService
      .filterIndustrialBuildingsInfrastructure(body)
      .subscribe({
        next: (res) => {
          this.resultadoChange.emit(res);
          this.loadingChange.emit(false);
        },
        error: () => {
          this.loadingChange.emit(false);
        },
      });
  }

  get statesBusca(): number[] {
    if (!this.filtrosBuscaSalvaAtivos?.AddressStateID) return [];
    return this.filtrosBuscaSalvaAtivos.AddressStateID.split(',').map((v) =>
      Number(v),
    );
  }

  get citiesBusca(): number[] {
    if (!this.filtrosBuscaSalvaAtivos?.AddressCityID) return [];
    return this.filtrosBuscaSalvaAtivos.AddressCityID.split(',').map((v) =>
      Number(v),
    );
  }

  toNumberArray(str: string | undefined): number[] {
    if (!str) return [];
    return str
      .split(',')
      .map((s) => Number(s))
      .filter((n) => !isNaN(n));
  }
  salvarBusca() {
    const nomeBusca = this.nomeBuscaInput.nativeElement.value.trim();
    if (!nomeBusca) {
      this.inputNomeBusca = false;
      setTimeout(() => {
        this.inputNomeBusca = true;
      }, 2000);
      return;
    }

    const body: any = {
      workModulesID: this.idModuloSelecionado || 5,
      addressRegionID: Number(this.regiaoFiltro.regiao ?? 0),
      addressStateID: this.regiaoFiltro.addressStateID ?? '0',
      addressCityID: this.regiaoFiltro.addressCityID ?? '0',
      infoID: this.detalhesSelecionados.map((d) => d.id).join(',') || '0',
      sectorID: this.setoresSelecionados.map((s) => s.id).join(',') || '0',
      workTypeID: this.tiposObraSelecionados.map((t) => t.id).join(',') || '0',
      scheduleID: this.cronogramaSelecionados.map((c) => c.id).join(',') || '0',
      valueBegin: this.valorObraSelecionado.de ?? 0,
      valueEnd: this.valorObraSelecionado.ate ?? 999999999,
      dateRegisteredUpdated: this.cadastradaEmSelecionado?.value ?? 0,
      workEndDateBegin: this.terminoObraSelecionado.dataInicio ?? null,
      workEndDateEnd: this.terminoObraSelecionado.dataFim ?? null,
      noResponsible: this.buscarSomenteSelecionados.find((b) => b.id === 1)
        ?.checked
        ? 1
        : 0,
      noDiscardedWork: this.buscarSomenteSelecionados.find((b) => b.id === 2)
        ?.checked
        ? 1
        : 0,
      pagination: {
        page: 1,
        pageSize: 50,
        shortcuts: 10,
        ordenation: '',
      },
      savedSearchName: nomeBusca,
    };

    this._filtroBuscaService.salvarBusca(body).subscribe({
      next: () => {
        this.exibirMensagem(
          'sucesso',
          'Busca salva com sucesso!',
          'Agora você pode acessá-la rapidamente através do menu de buscas salvas.',
        );
      },
      error: (err) => {
        console.error('Erro ao salvar busca:', err);
        this.exibirMensagem('erro', 'Erro', 'Erro ao salvar busca.');
      },
    });
  }

  limparFiltros() {
    this.filtroBuscaEstado.limpar(this.idModuloSelecionado || 5);
    this.setoresSelecionados = [];
    this.tiposObraSelecionados = [];
    this.detalhesSelecionados = [];
    this.cronogramaSelecionados = [];
    this.valorObraSelecionado = { de: null, ate: null };
    this.regiaoFiltro = {};

    this.filtroRegiaoComp?.restaurarPadrao();
    this.cadastradaEmSelecionado = {
      value: 0,
      description: 'Indiferente',
      checked: true,
    };
    this.terminoObraSelecionado = { dataInicio: null, dataFim: null };
    this.buscarSomenteSelecionados = [
      {
        id: 1,
        description: 'Buscar somente obras sem responsáveis',
        checked: false,
      },
      {
        id: 2,
        description: 'Não incluir obras descartadas',
        checked: false,
      },
    ];
    this.filtrosBuscaSalvaAtivos = null;
    this.filtrosSelecionados = {};

    localStorage.setItem('filtros_busca_outros_modulos', JSON.stringify([]));

    setTimeout(() => {
      this.onBuscarSomenteSelecionado([
        {
          id: 1,
          description: 'Buscar somente obras sem responsáveis',
          checked: false,
        },
        { id: 2, description: 'Não incluir obras descartadas', checked: false },
      ]);
    }, 0);

    this.salvarFiltrosNoLocalStorage();
  }

  private normalizeFiltroData(data: any): any {
    if (!data || typeof data !== 'object') return {};
    const pick = (...keys: string[]) => {
      for (const k of keys) {
        if (data[k] !== undefined && data[k] !== null && data[k] !== '') {
          return data[k];
        }
      }
      return undefined;
    };
    return {
      SectorID: pick('SectorID', 'sectorID', 'sectorId'),
      InfoID: pick('InfoID', 'infoID', 'infoId'),
      WorkTypeID: pick('WorkTypeID', 'workTypeID', 'workTypeId'),
      ScheduleID: pick('ScheduleID', 'scheduleID', 'scheduleId'),
      ValueBegin: pick('ValueBegin', 'valueBegin', 'valuebegin'),
      ValueEnd: pick('ValueEnd', 'valueEnd', 'valueend'),
      DateRegisteredUpdated: pick(
        'DateRegisteredUpdated',
        'dateRegisteredUpdated',
      ),
      WorkEndDateBegin: pick('WorkEndDateBegin', 'workEndDateBegin'),
      WorkEndDateEnd: pick('WorkEndDateEnd', 'workEndDateEnd'),
      AddressRegionID: pick(
        'AddressRegionID',
        'addressRegionID',
        'addressRegionId',
      ),
      AddressStateID: pick(
        'AddressStateID',
        'addressStateID',
        'addressStateId',
      ),
      AddressCityID: pick('AddressCityID', 'addressCityID', 'addressCityId'),
      noResponsible: pick('noResponsible', 'NoResponsible'),
      noDiscardedWork: pick('noDiscardedWork', 'NoDiscardedWork'),
      savedSearchName: pick('savedSearchName', 'searchName', 'SavedSearchName'),
    };
  }

  private iniciarPollBuscaSalva() {
    const pendentes = Object.keys(this.esperandoComponentesBuscaSalva).filter(
      (k) =>
        this.esperandoComponentesBuscaSalva[
          k as keyof typeof this.esperandoComponentesBuscaSalva
        ] === false,
    );
    if (pendentes.length === 0) {
      this.salvarFiltrosNoLocalStorage(undefined, false, true);
      return;
    }
    const inicio = Date.now();
    const poll = () => {
      const restantes = Object.keys(this.esperandoComponentesBuscaSalva).filter(
        (k) =>
          this.esperandoComponentesBuscaSalva[
            k as keyof typeof this.esperandoComponentesBuscaSalva
          ] === false,
      );
      if (restantes.length === 0) {
        clearTimeout(this.pollTimeoutBuscaSalva);
        this.salvarFiltrosNoLocalStorage(undefined, false, true);
        return;
      }
      if (Date.now() - inicio > 1500) {
        clearTimeout(this.pollTimeoutBuscaSalva);
        this.salvarFiltrosNoLocalStorage(undefined, false, true);
        return;
      }
      this.pollTimeoutBuscaSalva = setTimeout(poll, 120);
    };
    poll();
  }

  private marcarComponentePronto(
    tipo: 'detalhes' | 'tipos' | 'setores' | 'cronograma',
    selecionados: any[],
  ) {
    if (
      this.filtrosBuscaSalvaAtivos &&
      this.esperandoComponentesBuscaSalva[tipo] === false &&
      Array.isArray(selecionados)
    ) {
      this.esperandoComponentesBuscaSalva[tipo] = true;
    }
  }

  private marcarAlteracaoBuscaSalva() {
    if (this.filtrosBuscaSalvaAtivos && !this.buscaSalvaAlterada) {
      this.buscaSalvaAlterada = true;

      this.ultimoBodyEnviado = '';
    }
  }

  salvarEdicaoBusca() {
    if (!this.idEditandoBusca) {
      this.exibirMensagem('atencao', 'Atenção', 'ID da busca não encontrado para edição.');
      return;
    }

    let nomeEdicao = this.savedSearchName.trim();
    if (this.nomeBuscaEditadaInput) {
      const val = this.nomeBuscaEditadaInput.nativeElement.value.trim();
      if (val) nomeEdicao = val;
    }

    const body: any = {
      searchId: this.idEditandoBusca,
      workModulesID: this.idModuloSelecionado || 5,
      addressRegionID: Number(this.regiaoFiltro.regiao ?? 0),
      addressStateID: this.regiaoFiltro.addressStateID ?? '0',
      addressCityID: this.regiaoFiltro.addressCityID ?? '0',
      infoID: this.detalhesSelecionados.map((d) => d.id).join(',') || '0',
      sectorID: this.setoresSelecionados.map((s) => s.id).join(',') || '0',
      workTypeID: this.tiposObraSelecionados.map((t) => t.id).join(',') || '0',
      scheduleID: this.cronogramaSelecionados.map((c) => c.id).join(',') || '0',
      valueBegin: this.valorObraSelecionado.de ?? 0,
      valueEnd: this.valorObraSelecionado.ate ?? 999999999,
      dateRegisteredUpdated: this.cadastradaEmSelecionado?.value ?? 0,
      workEndDateBegin: this.terminoObraSelecionado.dataInicio ?? null,
      workEndDateEnd: this.terminoObraSelecionado.dataFim ?? null,
      noResponsible: this.buscarSomenteSelecionados.find((b) => b.id === 1)
        ?.checked
        ? 1
        : 0,
      noDiscardedWork: this.buscarSomenteSelecionados.find((b) => b.id === 2)
        ?.checked
        ? 1
        : 0,
      savedSearchName: nomeEdicao || this.savedSearchName || 'Busca Editada',
      pagination: { page: 1, pageSize: 50, shortcuts: 10, ordenation: '' },
    };

    this.loadingChange.emit(true);
    this.resultadoService.editSavdSearchs(body).subscribe({
      next: (res) => {
        this.loadingChange.emit(false);
        if (res?.success) {
          this.exibirMensagem('sucesso', 'Sucesso', 'Busca salva editada com sucesso!');
          this.savedSearchName = nomeEdicao;
        } else {
          this.exibirMensagem('atencao', 'Aviso', 'Edição concluída, resposta inesperada.');
          console.warn('Resposta edição busca (industrial):', res);
        }
      },
      error: (err) => {
        this.loadingChange.emit(false);

        this.exibirMensagem('erro', 'Erro', 'Erro ao editar busca.');
      },
    });
  }
}
